export * from './tab1.component'